import React from 'react';
import PropTypes from 'prop-types';
import { compose, branch, renderNothing } from 'recompose';

import Money from '../../components/Money';

const BookingFee = ({ fees, isChopMurrayHillShop }) => (
  <div>
    {!isChopMurrayHillShop && <div className="c-order-info__desc">Fees:</div>}
    {isChopMurrayHillShop && (
      <div className="c-order-info__desc">
        Fees:
        <br />
        <span className="c-order-info__subtitle">
          (only for Reserve & Pay)
        </span>
      </div>
    )}
    <div className="c-order-info__price"><Money>{fees}</Money></div>
  </div>
);

BookingFee.propTypes = {
  fees: PropTypes.number.isRequired,
  isChopMurrayHillShop: PropTypes.bool.isRequired,
};

export default compose(
  branch(
    props => !props.fees,
    renderNothing,
  ),
)(BookingFee);



// WEBPACK FOOTER //
// ./src/app/reservation/components/BookingFee.jsx